import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/_site/pricing')({
  head: () => ({
    meta: [
      { title: 'Pricing — your Everwake session pass' },
      {
        name: 'description',
        content:
          'One Everwake session pass is ten credits and gives you about two hours of play. Pricing will be announced at launch.',
      },
      { property: 'og:title', content: 'Pricing — your Everwake session pass' },
      {
        property: 'og:description',
        content:
          'Ten credits opens one complete Everwake session: about two hours of story, choices and consequence.',
      },
      { property: 'og:type', content: 'article' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
  }),
  component: Pricing,
});

function Pricing() {
  return (
    <div className="mx-auto max-w-3xl px-5 py-16">
      <p className="rule-line">Pricing</p>
      <h1 className="mt-4 font-display text-4xl md:text-5xl">
        A pass for a complete evening
      </h1>
      <p className="mt-6 text-lg text-muted-foreground">
        A session pass is ten credits and opens one complete session: about two hours, around ninety to a hundred spoken turns. Settle in with your game master, follow the story wherever your choices lead, and finish on a cliffhanger made for your return.
      </p>

      <div className="mt-10 rounded-xl border border-border bg-card/60 p-6 shadow-table">
        <p className="rule-line">Session pass</p>
        <p className="mt-3 font-display text-3xl">
          10 credits · about two hours
        </p>
        <p className="mt-3 text-sm text-muted-foreground">
          Ten credits reserve the full session, giving the evening room for conversation, exploration, danger and discovery.
        </p>
        <p className="mt-6 rounded-lg border border-primary/40 bg-primary/5 p-4 text-sm">Pricing announced at launch.</p>
      </div>

      <section className="mt-12">
        <h2 className="font-display text-2xl">Refunds, plainly</h2>
        <ul className="mt-4 space-y-2 text-muted-foreground">
          <li>Full refund if you leave inside the first five minutes.</li>
          <li>Pro-rata refund if the server fails on us.</li>
        </ul>
      </section>

      <section className="mt-12">
        <h2 className="font-display text-2xl">A free trial first</h2>
        <p className="mt-4 text-muted-foreground">
          New players get a short free trial on the calm preset, so you can judge the game before you pay for it. The length of the trial will be announced at launch alongside pricing.
        </p>
      </section>

      <section className="mt-12 border-t border-border/70 pt-10">
        <h2 className="font-display text-2xl">Join the controlled playtest</h2>
        <p className="mt-4 text-muted-foreground">
          Everwake is currently welcoming players through controlled playtests. Each session opens with a one-time pass issued personally by the team.
        </p>
        <Button asChild className="mt-5">
          <Link to="/playtest">Request a playtest pass</Link>
        </Button>
      </section>
    </div>
  );
}
